export const SET_STATION_ACTIVITY_OFFSET = 'SET_STATION_ACTIVITY_OFFSET';
export const SET_STATION_ACTIVITY_REGION = 'SET_STATION_ACTIVITY_REGION';
export const SET_STATION_ACTIVITY_START_DATE = 'SET_STATION_ACTIVITY_START_DATE';
export const SET_STATION_ACTIVITY_END_DATE = 'SET_STATION_ACTIVITY_END_DATE';

export const GET_STATION_ACTIVITY = 'GET_STATION_ACTIVITY';
export const GET_STATION_ACTIVITY_SUCCESS = 'GET_STATION_ACTIVITY_SUCCESS';
export const GET_STATION_ACTIVITY_FAILURE = 'GET_STATION_ACTIVITY_FAILURE';



// WEBPACK FOOTER //
// ./src/store/modules/stationactivity/mutation-types.js